import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "radio"]

  connect() {
    // Initialize theme
    const currentTheme = document.documentElement.getAttribute('data-theme') || 'light'
    document.documentElement.setAttribute('data-theme', currentTheme)
    
    // Set up radio change listeners if they exist
    if (this.hasRadioTarget) {
      this.radioTargets.forEach(radio => {
        radio.addEventListener("change", () => this.previewTheme(radio.value))
      })
    }

    // Set up system theme listener
    this.mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
    this.handleSystemThemeChange = this.handleSystemThemeChange.bind(this)
    this.mediaQuery.addEventListener('change', this.handleSystemThemeChange)

    // Apply initial theme
    if (currentTheme === 'system') {
      this.handleSystemThemeChange()
    } else {
      document.documentElement.classList.toggle('dark', currentTheme === 'dark')
    }
  }

  disconnect() {
    if (this.mediaQuery) {
      this.mediaQuery.removeEventListener('change', this.handleSystemThemeChange)
    }
  }

  previewTheme(theme) {
    // Update data-theme attribute
    document.documentElement.setAttribute('data-theme', theme)

    if (theme === 'system') {
      this.handleSystemThemeChange()
    } else {
      document.documentElement.classList.toggle('dark', theme === 'dark')
    }
  }

  handleSystemThemeChange() {
    const prefersDark = this.mediaQuery.matches
    if (document.documentElement.getAttribute('data-theme') === 'system') {
      document.documentElement.classList.toggle('dark', prefersDark)
    }
  }
}
